/** Canonical success/error colors for /analytics surfaces. */
export const ANALYTICS_GREEN = '#22c55e';
export const ANALYTICS_RED = '#dc2626';

/** RGB tuples derived from the canonical hex values above. */
const ANALYTICS_GREEN_RGB = '34, 197, 94';
const ANALYTICS_RED_RGB = '220, 38, 38';

/** Build a green tint; alpha must match existing rgba usages when substituted. */
export const analyticsGreenAlpha = (alpha) => `rgba(${ANALYTICS_GREEN_RGB}, ${alpha})`;

/** Build a red tint; alpha must match existing rgba usages when substituted. */
export const analyticsRedAlpha = (alpha) => `rgba(${ANALYTICS_RED_RGB}, ${alpha})`;
